import { useQuery } from '@apollo/client';
import React from 'react';
import CheckoutUserDataQuery from './CheckoutUserDataQuery';
import { CheckoutUserResponseData } from './types';

type result = {
  loading: boolean;
  userData?: CheckoutUserResponseData;
};

interface ICheckoutUserDataConnectorApollo {
  children: (result: result) => React.ReactElement;
}

const CheckoutUserDataConnectorApollo: React.FC<ICheckoutUserDataConnectorApollo> = ({
  children,
}) => {
  const { loading, error, data } = useQuery(CheckoutUserDataQuery, { fetchPolicy: 'no-cache' });

  const result: result = {
    loading,
  };

  if (error) {
    throw error;
  }

  if (!loading) {
    result.userData = { email: data.me.email, shipping: data.me.shipping };
  }

  return children(result);
};

export default CheckoutUserDataConnectorApollo;
